import { render, staticRenderFns } from "./BrandLoyalty.vue?vue&type=template&id=360f7fcc"
import script from "./BrandLoyalty.vue?vue&type=script&lang=js"
export * from "./BrandLoyalty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports